import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceCard = ({ icon, title, description, features, isHighlighted = false }) => {
  return (
    <div className={`
      relative p-6 md:p-8 rounded-2xl transition-all duration-300 hover:-translate-y-1
      ${isHighlighted 
        ? 'bg-primary/10 border-2 border-primary shadow-lg' 
        : 'bg-card border border-border hover:border-primary/50'
      }
    `}>
      {isHighlighted && (
        <div className="absolute -top-3 left-6 px-3 py-1 bg-primary text-primary-foreground text-xs font-bold rounded-full">
          MOST POPULAR
        </div>
      )}
      <div className={`
        inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-xl mb-4 md:mb-6
        ${isHighlighted ? 'bg-primary/20' : 'bg-muted'}
      `}>
        <Icon 
          name={icon} 
          size={24} 
          color={isHighlighted ? 'var(--color-primary)' : 'var(--color-foreground)'} 
        />
      </div>
      <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground mb-3 md:mb-4">
        {title}
      </h3>
      <p className="text-sm md:text-base text-muted-foreground mb-4 md:mb-6 leading-relaxed">
        {description}
      </p>
      <ul className="space-y-2 md:space-y-3">
        {features?.map((feature, index) => (
          <li key={index} className="flex items-start gap-2 md:gap-3">
            <Icon 
              name="Check" 
              size={18} 
              color="var(--color-success)" 
              className="flex-shrink-0 mt-0.5" 
            />
            <span className="text-sm md:text-base text-foreground">{feature}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceCard;